import React, { useState, useEffect } from "react";
import { CiCirclePlus } from "react-icons/ci";
import { useNavigate } from "react-router-dom";
import Sidebar from "../../Components/Sidebar";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchOfficeData,
  updateOfficeData,
} from "../../redux/actions/ITServicesAction";
import PageComponent from "../../Components/PageComponent";

function Office() {
  const navigate = useNavigate();

  const dispatch = useDispatch();
  const {
    data: officeData,
    loading,
    error,
  } = useSelector((state) => state.ITServices.office);

  const [id, setId] = useState(null);
  const [introduction, setIntroduction] = useState("");
  const [url, setUrl] = useState("");

  useEffect(() => {
    dispatch(fetchOfficeData());
  }, [dispatch]);

  useEffect(() => {
    if (officeData) {
      setId(officeData.id || null);
      setIntroduction(officeData.introduction || "");
      setUrl(officeData.url || "");
    }
  }, [officeData]);

  const handleUpdate = (e) => {
    e.preventDefault();
    if (!id) {
      alert("ID is missing. Unable to update introduction and url.");
      return;
    }
    dispatch(updateOfficeData(id, introduction, url));
  };

  if (loading) {
    return <div className="text-center text-primary-color">Loading...</div>;
  }

  if (error) {
    return <div className="text-center text-red-600">Error: {error}</div>;
  }
  return (
    <>
      <PageComponent>
        <div className="flex w-screen h-screen overflow-x-hidden bg-[#F8F7FA]">
          <div className="fixed top-0 left-0 w-64 h-full overflow-y-auto bg-white shadow-md">
            <Sidebar />
          </div>

          <div className="flex-1 p-6 ml-64">
            <div className="flex items-center space-x-2 text-3xl text-gray-500">
              <span> Student Support</span>
              <span>/</span>
              <span className="text-black">Service Menu</span>
            </div>

            <div className="flex items-center mt-4 space-x-4">
              <button
                className="flex items-center px-4 py-2  text-[#A8AAAE] rounded-lg shadow hover:bg-[#6C0B67]"
                onClick={() => navigate("/it-services/ims")}
              >
                <CiCirclePlus className="mr-2" />
                IMS
              </button>
              <button
                className="flex items-center px-4 py-2 text-[#A8AAAE] rounded-lg shadow hover:bg-gray-100"
                onClick={() => navigate("/it-services/service-menu")}
              >
                <CiCirclePlus className="mr-2" />
                LMS
              </button>
              <button
                className="flex items-center px-4 py-2 text-[#A8AAAE] rounded-lg shadow hover:bg-gray-100"
                onClick={() => navigate("/it-services/student-portal")}
              >
                <CiCirclePlus className="mr-2" />
                Student Portal
              </button>

              <button
                className="flex items-center px-4 py-2 text-white bg-[#92288C] rounded-lg shadow hover:bg-[#6C0B67]"
                onClick={() => navigate("/it-services/office")}
              >
                <CiCirclePlus className="mr-2" />
                Office 365
              </button>

              <button
                className="flex items-center px-4 py-2 text-[#A8AAAE] rounded-lg shadow hover:bg-gray-100"
                onClick={() => navigate("/it-services/online-payment")}
              >
                <CiCirclePlus className="mr-2" />
                Online Payments
              </button>

              <button
                className="flex items-center px-4 py-2 text-[#A8AAAE] rounded-lg shadow hover:bg-gray-100"
                onClick={() => navigate("/it-services/password-managment")}
              >
                <CiCirclePlus className="mr-2" />
                Smart Library
              </button>

              <button
                className="flex items-center px-4 py-2 text-[#A8AAAE] rounded-lg shadow hover:bg-gray-100"
                onClick={() => navigate("/it-services/help-desk")}
              >
                <CiCirclePlus className="mr-2" />
                IT Help Desk
              </button>
            </div>

            <div className="p-6 mt-6 bg-white rounded-lg shadow-md">
              <h2 className="text-2xl font-bold">Edit Office 365 </h2>
              <form onSubmit={handleUpdate}>
                <div className="mt-6 space-y-4">
                  <div>
                    <label className="block text-gray-700">Introduction</label>
                    <textarea
                      className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none"
                      placeholder="Enter vision message"
                      value={introduction}
                      onChange={(e) => setIntroduction(e.target.value)}
                      style={{ height: "50px", resize: "none" }}
                      required
                    />
                  </div>
                  <div>
                    <label className="block text-gray-700">Redirect URL</label>
                    <textarea
                      className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none"
                      placeholder="Enter mission message"
                      value={url}
                      onChange={(e) => setUrl(e.target.value)}
                      style={{ height: "50px", resize: "none" }}
                      required
                    />
                  </div>
                </div>
                <div className="flex justify-end mt-6 space-x-4">
                  <button
                    type="reset"
                    onClick={() => {
                      setIntroduction(officeData?.introduction || "");
                      setUrl(officeData?.url || "");
                    }}
                    className="px-4 py-2 text-[#A8AAAE] bg-gray-200 rounded-md hover:bg-gray-300"
                  >
                    Clear
                  </button>
                  <button
                    type="submit"
                    className="px-4 py-2 text-white bg-[#92288C] rounded-md hover:bg-[#6C0B67]"
                  >
                    Update
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </PageComponent>
    </>
  );
}

export default Office;
